import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [newPwd, setNewPwd] = useState('');
  const [confirmPwd, setConfirmPwd] = useState('');
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');
  const [done, setDone]       = useState(false);

  async function submit(e) {
    e.preventDefault();
    if (!newPwd || !confirmPwd) { setError(t('auth.fill_all')); return; }
    if (newPwd.length < 8) { setError(t('auth.password_too_short')); return; }
    if (newPwd !== confirmPwd) { setError(t('auth.password_mismatch')); return; }
    setLoading(true); setError('');
    try {
      const r = await fetch('/api/auth/reset-password', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ token, new_password: newPwd }),
      });
      const data = await r.json();
      if (!r.ok) throw new Error(data.error || 'Erreur');
      setDone(true);
      setTimeout(() => navigate('/'), 2500);
    } catch (e) { setError(e.message); }
    finally { setLoading(false); }
  }

  return (
    <div style={{
      minHeight:'100vh',
      background:'linear-gradient(135deg, #1A1A1A 0%, #2D2D2D 50%, #1A1A1A 100%)',
      display:'flex', alignItems:'center', justifyContent:'center', padding:20,
      fontFamily:"'Segoe UI', system-ui, sans-serif",
    }}>
      <div style={{ position:'fixed', top:0, left:0, width:200, height:4,
        background:'linear-gradient(90deg, #F18A00, transparent)' }}/>

      <div style={{ width:'100%', maxWidth:420 }}>
        <div style={{ textAlign:'center', marginBottom:36 }}>
          <div style={{ fontSize:30, fontWeight:900, letterSpacing:'-1px', color:'#fff' }}>
            ARCUS<span style={{ color:'#F18A00' }}>CONNECT</span>
          </div>
          <div style={{ fontSize:12, color:'#64748B', marginTop:4, letterSpacing:'.12em', textTransform:'uppercase' }}>CRM</div>
        </div>

        <div style={{ background:'#fff', borderRadius:16, padding:36, boxShadow:'0 25px 60px rgba(0,0,0,.4)' }}>
          {!done ? (
            <>
              <h1 style={{ fontSize:20, fontWeight:700, margin:'0 0 6px', color:'#1A1A1A' }}>{t('auth.reset_title')}</h1>
              <p style={{ fontSize:13, color:'#64748B', margin:'0 0 22px' }}>{t('auth.reset_desc')}</p>

              {error && (
                <div style={{ background:'#FCEBEB', color:'#A32D2D', borderRadius:8, padding:'10px 14px', fontSize:13, marginBottom:16 }}>
                  ⚠ {error}
                </div>
              )}

              <form onSubmit={submit}>
                <div style={{ marginBottom:14 }}>
                  <label style={{ fontSize:12, fontWeight:500, color:'#64748B', display:'block', marginBottom:6 }}>{t('auth.new_password')}</label>
                  <div style={{ position:'relative' }}>
                    <input type={showPwd?'text':'password'} value={newPwd} onChange={e=>setNewPwd(e.target.value)}
                      autoFocus minLength={8}
                      style={{ width:'100%', boxSizing:'border-box', border:'1.5px solid #E5E7EB', borderRadius:8,
                        padding:'11px 44px 11px 14px', fontSize:14, fontFamily:'inherit', outline:'none', transition:'border-color .15s' }}
                      onFocus={e=>e.target.style.borderColor='#F18A00'} onBlur={e=>e.target.style.borderColor='#E5E7EB'}/>
                    <button type="button" onClick={()=>setShowPwd(p=>!p)}
                      style={{ position:'absolute', right:12, top:'50%', transform:'translateY(-50%)',
                        background:'none', border:'none', cursor:'pointer', fontSize:16, padding:2 }}>
                      {showPwd ? '🙈' : '👁'}
                    </button>
                  </div>
                </div>
                <div style={{ marginBottom:18 }}>
                  <label style={{ fontSize:12, fontWeight:500, color:'#64748B', display:'block', marginBottom:6 }}>{t('auth.confirm_password')}</label>
                  <input type={showPwd?'text':'password'} value={confirmPwd} onChange={e=>setConfirmPwd(e.target.value)}
                    minLength={8}
                    style={{ width:'100%', boxSizing:'border-box', border:'1.5px solid #E5E7EB', borderRadius:8,
                      padding:'11px 14px', fontSize:14, fontFamily:'inherit', outline:'none', transition:'border-color .15s' }}
                    onFocus={e=>e.target.style.borderColor='#F18A00'} onBlur={e=>e.target.style.borderColor='#E5E7EB'}/>
                </div>
                <button type="submit" disabled={loading}
                  style={{ width:'100%', padding:'12px', background:'#F18A00', color:'#161616',
                    border:'none', borderRadius:8, fontSize:15, fontWeight:500,
                    cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? .7 : 1 }}>
                  {loading ? '…' : t('auth.reset_btn')}
                </button>
              </form>
            </>
          ) : (
            <>
              <div style={{ background:'#E1F5EE', border:'1px solid #B6E5D2', borderRadius:10,
                padding:'14px 16px', color:'#0F6E56', fontSize:13, display:'flex', alignItems:'center', gap:9 }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0F6E56" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12l5 5l10 -10"/>
                </svg>
                {t('auth.reset_success')}
              </div>
              <div style={{ textAlign:'center', marginTop:16, fontSize:12, color:'#64748B' }}>
                {t('auth.redirecting')}
              </div>
            </>
          )}
        </div>

        <div style={{ textAlign:'center', marginTop:20, fontSize:11, color:'#4B5563' }}>
          Arcus Solutions · arcus-solutions.fr
        </div>
      </div>
    </div>
  );
}
